import { Typography, Box, Tabs, Tab, Paper } from '@mui/material';
import { useState } from 'react';
import InventoryReport from '../components/InventoryReport';
import TransferHistory from '../components/TransferHistory';
import EquipmentShortageReport from '../components/EquipmentShortageReport';
import { useInventory } from '../contexts/InventoryContext';

/**
 * Reports Page Component
 * Contains different report types and export functionality
 */
const ReportsPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { loading, error } = useInventory();

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box>
      <Typography variant="h6" component="h1" gutterBottom>
        Inventory Reports
      </Typography>
      
      <Typography variant="body2" paragraph>
        Generate various inventory reports and export data. Select a report type to begin.
      </Typography>
      
      <Paper sx={{ mb: 4, borderRadius: 1 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab label="Inventory Reports" />
          <Tab label="Transfer History" />
          <Tab label="Equipment Needs" />
          <Tab label="Export Data" disabled />
          <Tab label="Custom Reports" disabled />
        </Tabs>
      </Paper>
      
      {/* Tab Panels */}
      <TabPanel value={activeTab} index={0}>
        <InventoryReport />
      </TabPanel>
      
      <TabPanel value={activeTab} index={1}>
        <TransferHistory />
      </TabPanel>
      
      <TabPanel value={activeTab} index={2}>
        <EquipmentShortageReport />
      </TabPanel>
      
      <TabPanel value={activeTab} index={3}>
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography variant="body2" color="text.secondary">
            Export functionality coming soon.
          </Typography>
        </Paper>
      </TabPanel>
      
      <TabPanel value={activeTab} index={4}>
        <Paper elevation={3} sx={{ p: 3, mb: 4 }}>
          <Typography variant="body2" color="text.secondary">
            Custom report builder coming soon.
          </Typography>
        </Paper>
      </TabPanel>
    </Box>
  );
};

// Tab Panel Component
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`reports-tabpanel-${index}`}
      aria-labelledby={`reports-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
};

export default ReportsPage;